import React, { useState } from 'react';
import '../styles/Research.css';
import { Link } from 'react-router-dom';


const Blog = () => {
  const [filter, setFilter] = useState('');

  // Sample publications data
  const publications = [
    // {
    //   id: 1,
    //   title: "Will add soon",
    //   authors: "",
    //   journal: "",
    //   date: "",
    //   year: "2025",
    //   category: "",
    //   image: require('../assets/profile.jpg'),
    //   route: "/blogs/blog-one"
    // },
    // {
    //   id: 2,
    //   title: "Deep Learning Approaches for Medical Image Analysis",
    //   authors: "John Smith, Jane Doe, Mike Johnson",
    //   journal: "IEEE Transactions on Medical Imaging",
    //   date: "Mar 2024",
    //   year: "2024",
    //   category: "IEEE",
    //   image: "/api/placeholder/120/120",
    //   route: "/blogs/blog-one"
    // },
    // {
    //   id: 3,
    //   title: "Novel Techniques in Brain Tumor Segmentation",
    //   authors: "Sarah Wilson, David Brown, Lisa Chen",
    //   journal: "Medical Image Analysis",
    //   date: "Feb 2024",
    //   year: "2024",
    //   category: "MIA",
    //   image: "/api/placeholder/120/120",
    //   route: "/blogs/blog-one"
    // }
  ];

  const filteredPublications = publications.filter(pub =>
    pub.title.toLowerCase().includes(filter.toLowerCase()) ||
    pub.authors.toLowerCase().includes(filter.toLowerCase()) ||
    pub.journal.toLowerCase().includes(filter.toLowerCase())
  );

  //grouping 
  const groupedByYear = filteredPublications.reduce((acc, pub) => {
    if (!acc[pub.year]) {
      acc[pub.year] = [];
    }
    acc[pub.year].push(pub);
    return acc;
  }, {});

  return (
    <div className="research-container">
      <div className="research-content">
        {/* Header */}
        <div className="research-header">
          <h1 className="research-title">Blogs</h1>
          <p className="research-subtitle">
            Migrating the website, will add old and new posts soon.
          </p>
        </div>

        {/* Filter Input and bar*/}
        {/* <div className="filter-container">
          <input
            type="text"
            placeholder="Type to filter"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="filter-input"
          />
        </div> */}

        {/* Publications by Year */}
        {Object.keys(groupedByYear)
          .sort((a, b) => b - a)
          .map(year => (
            <div key={year} className="year-section">
              {/* Year Header */}
              <div className="year-header">
                <h2 className="year-title">{year}</h2>
                <br />
                <hr className='divider' />
              </div>

              {/* Publications */}
              <div className="publications-list">
                {groupedByYear[year].map(pub => (
                  <Link className="no-underline" to={`${pub.route}`}>
                    <div key={pub.id} className="publication-card">
                      {/* Category Badge */}
                      {/* <div className="category-container">
                      <span className={`category-badge ${getCategoryColorClass(pub.category)}`}>
                        {pub.category}
                      </span>site
                    </div> */}

                      {/* Publication Image */}
                      <div className="simple-project-image">
                          <img className="simple-image-placeholder" src={pub.image} />
                      </div>

                      {/* Publication Details */}
                      <div className="publication-details">
                        <h3 className="publication-title">
                          {pub.title}
                        </h3>
                        <p className="publication-authors">
                          {pub.authors}
                        </p>
                        <p className="publication-journal">
                          {pub.journal}, {pub.date}
                        </p>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          ))}

        {filteredPublications.length === 0 && (
          <div className="no-results">
            <p className="no-results-text"></p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Blog